import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { AssigneeModelSchema } from '../../shared/assignee-model.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { RejectReasonSchema } from '../../shared/reject-reason.schema';
import { ReassigneeTypeSchema, refineReassigneeFields } from '../../shared/reassignee-type.schema';
/**
 * Reassign Recording Request Schema
 * POST /api/v2/process-step-recording/:id/reassign
 * Reassigns a recording with a specific reason and optional reassignee
 *
 * When rejectReason is 're-assign', both reAssigneeId and reAssigneeModel
 * are required. The reAssigneeModel discriminates which collection to look
 * the id up in (User / Team / System / ExternalContact). reAssigneeType
 * defaults to 'entity'; when 'suggestion', reAssigneeId is an EntitySuggestion
 * id (also a 24-hex ObjectId) and reAssigneeModel is restricted to System /
 * Team.
 */ export const ReassignRecordingRequestSchema = z.object({
    rejectReason: RejectReasonSchema,
    reAssigneeId: ObjectIdSchema.optional(),
    reAssigneeModel: AssigneeModelSchema.optional(),
    reAssigneeType: ReassigneeTypeSchema.default('entity')
}).superRefine(refineReassigneeFields);
/**
 * Reassign Recording Response Schema
 * Returned on successful recording reassignment
 * Returns void - no response body
 */ export const ReassignRecordingResponseSchema = z.void();
/**
 * Reassign Recording Error Schema
 * Returned when recording reassignment fails
 */ export const ReassignRecordingErrorSchema = BaseErrorSchema;

//# sourceMappingURL=reassign-recording.schema.js.map